/* eslint-disable react/prefer-es6-class, react/sort-comp, default-case, react/jsx-no-bind */
import React from 'react';
import * as Paths from 'es6/core/paths';
import { t } from 'es6/services/localization';
import { language } from 'es6/helpers/localization';
import Popover from 'es6/components/common/popover';
import ProgressBar from 'es6/components/common/progress-bar';
import { ContentFigureSizes, ContentFigure } from 'es6/components/common/content-figure';
import StatsMixin from 'es6/components/home/stats-mixin';

/**
 * Passing in the language is really important, as it determines which grouping
 * to use for the Study All details.
 */
const RecommendedNext = React.createClass({
  displayName: 'RecommendedNext',

  mixins: [StatsMixin],

  propTypes: {
    aggregateMemory: React.PropTypes.object.isRequired,
    goal: React.PropTypes.object.isRequired,
    groupings: React.PropTypes.array.isRequired,
    language: React.PropTypes.string.isRequired,
    onLanguageChange: React.PropTypes.func.isRequired,
  },

  getSelectedGrouping() {
    return this.props.groupings.filter((g) => g.grouping.cueLanguageCode === this.props.language)[0];
  },

  /**
   * Overrides the statistic pill tabs from StatsMixin.
   *
   * @param {String} type
   * @returns {String}
   */
  getStatString(type) {
    switch (type) {
      case 'started':
        return t('items-started');
      case 'items-zone-1':
        return t('items-zone-1');
      case 'items-zone-2':
        return t('items-mastered');
    }

    return '';
  },

  getLanguages() {
    return this.props.groupings.map((g) => g.grouping.cueLanguageCode);
  },

  render() {
    const goal = this.props.goal;
    const aggregate = this.props.aggregateMemory;
    let progress = aggregate.items.progress;
    const grouping = this.getSelectedGrouping();

    return (
      <section className="content-container content-row-1 recommended-next">
        <header className="content-details">
          <div className="details-primary">{t('dashboard.recommended-next')}</div>
        </header>

        <div className="content-primary">
          <div className="course-picture">
            <ContentFigure size={ContentFigureSizes.MEDIUM} imgSrc={goal.icon} />
          </div>

          <div className="recommended-course">
            <h2 className="course-title ellipsis hinted">
              <a href={Paths.course(goal.id)} title={goal.title}>{goal.title}</a>
            </h2>

            <ProgressBar progress={progress} showProgressTag />

            <ul className="content-columns content-stats">
              {this.renderStats(goal, aggregate, false)}
            </ul>
          </div>

          <div className="action-item">
            <a href={Paths.studyGoal(goal.id)} rel="app" className="btn launch">{t('start')}</a>

            <section className="item-data">
              <span className="secondary">{t('ready-label')} </span>
              <span className="primary">{this.props.aggregateMemory.items.eligibleItemsCount}</span>
            </section>
          </div>

          <div className="study-all-seperator" />

          <div className="study-all">
            {this.renderLanguageSelector()}

            <a href={Paths.studyAll(this.props.language)} rel="app" className="btn btn-bar launcher-iknow">
              {t('study-all.label')}
            </a>

            <div className="item-details">
              <span className="description items-to-study">{t('ready-label', { context: 'recommended-next' })}</span>
              <span className="item-count"> {grouping.items.eligibleItemsCount}</span>
            </div>
          </div>
        </div>
      </section>
    );
  },

  renderLanguageSelector() {
    const languages = this.getLanguages();

    if (languages.length <= 1) {
      return null;
    }

    return (
      <div className="language-selector-container">
        <Popover align="bottom" content={this.renderLanguageMenu()}>
          <div className="language-selector">
            <div className="language-selected">{language(this.props.language)}</div>
            <div className="glyph glyph-triangle-down"></div>
          </div>
        </Popover>
      </div>
    );
  },

  renderLanguageMenu() {
    return (
      <aside className="content-menu study-language-selector">
        <ul className="menu-category">
          {this.props.groupings.map((g) => {
            let className = 'menu-item';
            let langCode = g.grouping.cueLanguageCode;
            let eligibleItemsCount = g.items.eligibleItemsCount;

            if (langCode === this.props.language) {
              className += ' selected';
            }

            return (<li key={langCode} onClick={this.props.onLanguageChange.bind(null, langCode)} className={className}>{language(langCode)} ({eligibleItemsCount})</li>);
          })}
        </ul>
      </aside>
    );
  },
});

export default RecommendedNext;
